import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MpsPostLoginUrlHelper } from '../helpers/mps-post-login-url.helper';
import { mpsRouteNames } from '../mps-route-names';
import { MpsUserService } from '../services/mps-user.service';

export const MpsLoggedInGuard = (_route?: unknown, state?: unknown) => {
  const router = inject(Router);
  const userService = inject(MpsUserService);

  if (userService.isLoggedIn()) {
    return true;
  }

  // Wired as both `canActivate` and `canLoad`, so `state` is a `RouterStateSnapshot` in one case
  // and a `UrlSegment[]` in the other — hence the loose types and the defensive read.
  MpsPostLoginUrlHelper.capture((state as { url?: string } | undefined)?.url);

  return router.navigateByUrl(mpsRouteNames.auth + '/' + mpsRouteNames.login);
};
